import { Injectable} from '@angular/core';
import { environment } from '../../environments/environment';

// import * as firebase from 'firebase';

import { auth } from 'firebase/app';
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import {Observable} from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  userData:any;
  user: Observable<firebase.User>;// Save logged in user data
  // noAuthHeader = { headers: new HttpHeaders({ 'NoAuth': 'True' }) };

  constructor(
    public afs: AngularFirestore,   // Inject Firestore service
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    private http: HttpClient
  ) {
    /* Saving user data in sessionstorage when 
    logged in and setting up null when logged out */
    this.afAuth.authState.subscribe(userDetail => {
      this.user = afAuth.authState;
      if (userDetail) {
        this.userData = userDetail;
        sessionStorage.setItem('user', JSON.stringify(this.userData));
        JSON.parse(sessionStorage.getItem('user'));
      } else {
        sessionStorage.setItem('user', null);
        JSON.parse(sessionStorage.getItem('user'));
      }
    })
  }

  // Sign in with email/password
  SignIn(email, password) {
    return this.afAuth.auth.signInWithEmailAndPassword(email, password);
  }

  // Sign out 
  SignOut() {
    return this.afAuth.auth.signOut();
  }

  // Reset passwrod request
  ResetPassword(passwordResetEmail) {
    return this.afAuth.auth.sendPasswordResetEmail(passwordResetEmail);
  }

 

  // Add New User (For callable function)
  // createUser(data) {
  //   return firebase.functions().httpsCallable('create_user')(data);
  // }


  /* Setting up user data when sign in with username/password, 
  sign up with username/password and sign in with social auth  
  provider in Firestore database using AngularFirestore + AngularFirestoreDocument service */
  /*SetUserData(user) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
    const userData  = {
      uid: user.uid,
      email: user.email,
      firstName: user.displayName,
      lastName : '',
      password : '',
      status: true
    }
    return userRef.set(userData, {
      merge: true
    })
  }*/
}
